import React from 'react';
import { DraggerButtonSC } from './dragger-button.styled';
import { useTheme } from 'styled-components';
import Typography from '../../../typography';
import { UploadOutlined } from '@icon';

type DraggerButtonProps = Omit<
  React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
  'ref'
> & {
  size?: number;
} & (
    | {
        children?: never;
        description?: React.ReactNode;
      }
    | {
        children: React.ReactNode;
        description?: never;
      }
  );

const DraggerButton = (
  { size = 100, children, description, ...restProps }: DraggerButtonProps,
  ref?: React.Ref<HTMLDivElement>,
) => {
  const theme = useTheme();

  if (children) {
    return (
      <DraggerButtonSC {...restProps} ref={ref} size={size}>
        {children}
      </DraggerButtonSC>
    );
  }

  return (
    <DraggerButtonSC {...restProps} ref={ref} size={size}>
      <div className="ui-upload-drag-trigger-wrapper">
        <UploadOutlined color={theme.color.tint.action} height={32} />
      </div>
      {description ? (
        <Typography
          className="ui-upload-drag-description"
          style={{
            color: theme.color.tint.action,
            padding: '0 8px',
            textAlign: 'center',
            userSelect: 'none',
          }}
          display="captionLarge"
        >
          {description}
        </Typography>
      ) : null}
    </DraggerButtonSC>
  );
};

export default React.forwardRef(DraggerButton);
